import * as PIXI from 'pixi.js';
import {
    game
} from "../../Game"
import {
	editorSettings
} from './editorSettings';
import { fillRect } from '../../utils/pixiGraphics';
import { getClones, moveClonesWithOrigin } from './groupClones';

const vec1 = new Box2D.b2Vec2();

export const isBodyGroup = body => {
	return (body.mySprite.data.vertices.length > 1 || body.myTexture);
}

export const setBodyGroupOpacity = (body, opacity) => {
	body.mySprite.alpha = opacity;
	if(body.myTexture){
		if([game.editor.object_ANIMATIONGROUP, game.editor.object_GRAPHICGROUP].includes(body.myTexture.type)){
			body.myTexture.alpha = opacity * body.myTexture.data.transparancy;
		}else{
			body.myTexture.alpha = opacity;
		}
	}
}

export const startEditingGroup = () => {
	const editor = game.editor;

	if(editor.groupEditing) return;


	editor.lockSaving = true;

	editor.groupMinChildIndex = editor.textures.children.length-1;

	editor.groupEditingObject = null;
	if(editor.selectedPhysicsBodies.length > 0){
		editor.groupEditingObject = editor.selectedPhysicsBodies[0].mySprite;
	}else{
		editor.groupEditingObject = editor.selectedTextures[0];
	}
	editor.groupEditingObject.children.forEach( obj => obj.visible = false);
	editor.groupEditingObject.oldVisible = editor.groupEditingObject.visible;
	editor.groupEditingObject.visible = true;

	if(editor.groupEditingObject.myBody && editor.groupEditingObject.myBody.myTexture){
		editor.groupEditingObject.myBody.myTexture.oldVisible = editor.groupEditingObject.myBody.myTexture.visible;
		editor.groupEditingObject.myBody.myTexture.visible = true;
		editor.groupEditingObject.myBody.myTexture.children.forEach(obj =>{
			obj.oldVisible = obj.visible;
			obj.visible = false
		});
	}

	// add black overlay
	editor.groupEditingBlackOverlay = new PIXI.Graphics();
	fillRect(editor.groupEditingBlackOverlay, -editorSettings.worldSize.width/2, -editorSettings.worldSize.height/2, editorSettings.worldSize.width, editorSettings.worldSize.height, 0x000000);
	editor.groupEditingBlackOverlay.alpha = 0.3;
	editor.groupEditingBlackOverlay.data = {};
	editor.textures.addChild(editor.groupEditingBlackOverlay);

	const clones = getClones(editor.selectedPhysicsBodies[0] || editor.selectedTextures[0]).length;

	// clone object and ungroup, keeping what was copied before
	const copiedJSON = editor.copiedJSON;
	const copiedCenter = {x: editor.copiedCenterPosition.get_x(), y: editor.copiedCenterPosition.get_y()};
	editor.copiedJSON = editor.copySelection(true);
	editor.pasteSelection(true);

	let clonedSprite;
	if(editor.selectedPhysicsBodies.length > 0){
		clonedSprite = editor.selectedPhysicsBodies[0].mySprite;
		editor.updateBodyPosition(clonedSprite.myBody);
	}else{
		clonedSprite = editor.selectedTextures[0];
	}
	editor.ungroupObjects();

	editor.copiedJSON = copiedJSON;
	editor.copiedCenterPosition.Set(copiedCenter.x, copiedCenter.y);
	// this must come after ungroup else it won't work
	editor.groupEditing = true;

	if (clones) editor.showTimedToolTip(`Editing all ${clones} clones`);

}

export const stopEditingGroup = () => {
	const editor = game.editor;
	if(!editor.groupEditing) return;

	// small cleanup
	editor.groupEditing = false;
	editor.groupEditingObject.children.forEach( obj => obj.visible = true);
	editor.groupEditingObject.visible = editor.groupEditingObject.oldVisible;
	delete editor.groupEditingObject.oldVisible;


	if(editor.groupEditingObject.myBody && editor.groupEditingObject.myBody.myTexture){
		editor.groupEditingObject.myBody.myTexture.visible = editor.groupEditingObject.myBody.myTexture.oldVisible;
		delete editor.groupEditingObject.myBody.myTexture.oldVisible;
		editor.groupEditingObject.myBody.myTexture.children.forEach(obj => {
			obj.visible = obj.oldVisible;
			delete obj.oldVisible;
		});
	}

	editor.groupEditingBlackOverlay.parent.removeChild(editor.groupEditingBlackOverlay);
	delete editor.groupEditingBlackOverlay;

	editor.selectedPhysicsBodies = [];
	editor.selectedTextures = [];


	// we ungroup any groups created
	for(let i = editor.groupMinChildIndex+1; i< editor.textures.children.length; i++){
		const sprite = editor.textures.children[i];
		if(sprite.data.type === editor.object_BODY){
			editor.selectedPhysicsBodies.push(sprite.myBody)
		}else{
			// dont push textures that are grouped inside a group -_-
			if(!sprite.myBody && sprite.data.type !== editor.object_ANIMATIONGROUP) editor.selectedTextures.push(sprite);
		}
	}

	// first ungroup any groups created
	editor.ungroupObjects();


	editor.selectedPhysicsBodies = [];
	editor.selectedTextures = [];

	// we regroup all the ungrouped shapes
	for(let i = editor.groupMinChildIndex+1; i< editor.textures.children.length; i++){
		const sprite = editor.textures.children[i];
		if(sprite.data.type === editor.object_BODY){
			editor.selectedPhysicsBodies.push(sprite.myBody)
		}else{
			// dont push textures that are grouped inside a group -_-
			if(!sprite.myBody) editor.selectedTextures.push(sprite);
		}
	}

	// TODO: fix graphics / texts / animations
	// Remove Auto save when editing
	// Reset editor when going in test mode or changing tools

	// we must first restore the rotation
	editor.groupObjects();

	const allObjects = editor.selectedPhysicsBodies.length > 0 ? editor.selectedPhysicsBodies : editor.selectedTextures;
	editor.applyToObjects(editor.TRANSFORM_ROTATE, -editor.groupEditingObject.rotation * editor.RAD2DEG, allObjects, true);

	editor.ungroupObjects();
	editor.groupObjects();

	// we find the grouped object assign its properties to the original and then delete it
	let clonedSprite;
	let isBody = false;
	let groupDeleted = false;
	if(editor.selectedPhysicsBodies.length > 0){
		clonedSprite = editor.selectedPhysicsBodies[0].mySprite;
		editor.updateBodyPosition(clonedSprite.myBody);
		isBody = true;
	}else if(editor.selectedTextures.length > 0){
		clonedSprite = editor.selectedTextures[0];
	}else{
		// everything got deleted
		groupDeleted = true;
	}

	if(!groupDeleted){
		delete clonedSprite.data.ID;

		const xDif = editor.groupEditingObject.data.x - clonedSprite.data.x;
		const yDif = editor.groupEditingObject.data.y - clonedSprite.data.y;

		// Object.assign(editor.groupEditingObject.data, clonedSprite.data);

		// we then update the visuals for the group

		if(isBody){
			// if we go from a body to a body
			if(editor.groupEditingObject.myBody){

				editor.groupEditingObject.data.colorFill = clonedSprite.data.colorFill;
				editor.groupEditingObject.data.colorLine = clonedSprite.data.colorLine;
				editor.groupEditingObject.data.lineWidth = clonedSprite.data.lineWidth;
				editor.groupEditingObject.data.transparancy = clonedSprite.data.transparancy;
				editor.groupEditingObject.data.vertices = clonedSprite.data.vertices;
				editor.groupEditingObject.data.density = clonedSprite.data.density;
				editor.groupEditingObject.data.collision = clonedSprite.data.collision;
				editor.groupEditingObject.data.radius = clonedSprite.data.radius;
				editor.groupEditingObject.data.restitution = clonedSprite.data.restitution;
				editor.groupEditingObject.data.friction = clonedSprite.data.friction;

				editor.updateBodyFixtures(editor.groupEditingObject.myBody);
				editor.updateBodyShapes(editor.groupEditingObject.myBody);
				editor.setBodyCollision(editor.groupEditingObject.myBody, editor.groupEditingObject.data.collision);
				editor.groupEditingObject.myBody.ResetMassData();

				const position = vec1;
				position.set_x(editor.groupEditingObject.myBody.GetPosition().get_x() - xDif);
				position.set_y(editor.groupEditingObject.myBody.GetPosition().get_y() - yDif);
				editor.groupEditingObject.myBody.SetTransform(position, editor.groupEditingObject.myBody.GetAngle());
				moveClonesWithOrigin(editor.groupEditingObject.myBody, -xDif, -yDif);

				const originalTexture = editor.groupEditingObject.myBody.myTexture;
				const clonedTexture = clonedSprite.myBody.myTexture;
				if(clonedTexture){

					if(originalTexture){
						delete clonedTexture.myBody.myTexture;
						clonedTexture.data.ID = originalTexture.data.ID;
						editor.groupEditingObject.myBody.myTexture = clonedTexture;
						clonedTexture.data.bodyID = originalTexture.data.bodyID;
						clonedTexture.myBody = editor.groupEditingObject.myBody;

						originalTexture.parent.swapChildren(originalTexture, clonedTexture);
						editor.deleteObjects([originalTexture]);
					}else{
						delete clonedTexture.myBody.myTexture;
						editor.groupEditingObject.parent.addChildAt(clonedTexture, editor.groupMinChildIndex+1);
						editor.setTextureToBody(editor.groupEditingObject.myBody, clonedTexture, clonedTexture.data.texturePositionOffsetLength, clonedTexture.data.texturePositionOffsetAngle, clonedTexture.data.textureAngleOffset);
					}
				} else if(originalTexture){
					editor.groupEditingObject.renderable = true;
					editor.removeTextureFromBody(editor.groupEditingObject.myBody, originalTexture);
					editor.deleteObjects([originalTexture]);
				}
			}else{
				// we go from a graphic to a body

				const originalTexture = editor.groupEditingObject;
				originalTexture.parent.swapChildren(originalTexture, clonedSprite);
				editor.deleteObjects([originalTexture]);

				editor.selectedPhysicsBodies = [];

				const clonedTexture = clonedSprite.myBody.myTexture;

				if(clonedTexture){
					const targetIndex = clonedSprite.parent.getChildIndex(clonedSprite);
					clonedSprite.parent.addChildAt(clonedTexture, targetIndex+1);
				}


			}
		} else {
			// in case we had a body in the group and we removed it so we are left with just a graphic group
			if(editor.groupEditingObject.myBody){
				const originalTexture = editor.groupEditingObject.myBody.myTexture;
				if(originalTexture){
					originalTexture.parent.swapChildren(originalTexture, clonedSprite);
				}else{
					editor.groupEditingObject.parent.swapChildren(editor.groupEditingObject, clonedSprite);
				}

				editor.deleteObjects([editor.groupEditingObject.myBody]);
				editor.selectedTextures = [];
			}else{
				editor.groupEditingObject.data.graphicObjects = clonedSprite.data.graphicObjects;
				editor.groupEditingObject.data.textureScale = clonedSprite.data.textureScale;

				editor.updateGraphicGroupShapes(editor.groupEditingObject);
				editor.groupEditingObject.x -= xDif;
				editor.groupEditingObject.y -= yDif;
				moveClonesWithOrigin(editor.groupEditingObject, -xDif, -yDif);
				editor.updateObject(editor.groupEditingObject, editor.groupEditingObject.data);
			}
		}

		// TO DO GRAPHIC GROUP TO BODY GROUP WITH GRAPHIC

	}else{

		if(editor.groupEditingObject.data.type === editor.object_BODY){
			editor.deleteObjects([editor.groupEditingObject.myBody]);
		}else{
			editor.deleteObjects([editor.groupEditingObject]);
		}
	}


	// we restore the editor
	editor.groupEditingObject = null;


	// we can now delete things again so we delete the cloned group
	editor.deleteSelection();

	// restore last bits
	editor.groupMinChildIndex = -1;
	editor.selectedTool = -1;
	editor.selectTool(editor.tool_SELECT)

	editor.lockSaving = false;

	// store the new edited group
	editor.storeUndoMovementDebounced();

}
